// src/api/auth.ts
import { request, setStoredToken } from "./http";
import type { AuthResponse, User } from "./types";

export type RegisterResponse = {
  ok: boolean;
  emailHint?: string | null;
};

export async function verifyEmail(token: string): Promise<void> {
  await request("/auth/verify", {
    method: "POST",
    body: { token },
    auth: false,
  });
}

export async function resendVerification(email: string): Promise<void> {
  await request("/auth/resend-verification", {
    method: "POST",
    body: { email },
    auth: false,
  });
}

export async function login(email: string, password: string): Promise<User> {
  const res = await request<AuthResponse>("/auth/login", {
    method: "POST",
    body: { email, password },
    auth: false,
  });
  setStoredToken(res.accessToken);
  return res.user;
}

export async function register(
  email: string,
  password: string,
  displayName?: string
): Promise<RegisterResponse> {
  // Backend returns { ok, emailHint }, no token, no user
  return await request<RegisterResponse>("/auth/register", {
    method: "POST",
    body: { email, password, displayName },
    auth: false,
  });
}

export async function logout(): Promise<void> {
  try {
    await request("/auth/logout", { method: "POST", auth: true });
  } catch {
    // ignore
  }
  setStoredToken(null);
}

export async function requestMagicLink(email: string): Promise<void> {
  await request("/auth/magic", {
    method: "POST",
    body: { email },
    auth: false,
  });
}
